import api from '@/api'
import * as types from '../mutation-types'

// initial state
const state = {
  all: []
}

// getters
const getters = {
  allJenjang: state => state.all
}

// actions
const actions = {
  getAllJenjang ({ commit }) {
    api.get('/v1/public/jenjang_prodi')
      .then(response => {
        let responseData = response.data
        commit(types.JENJANG_RECEIVE, { responseData })
      })
      .catch(e => {
        // FIXME: Tell our user when we got some errors
        console.log(e)
      })
  }
}

// mutations
const mutations = {
  [types.JENJANG_RECEIVE] (state, { responseData }) {
    state.all = responseData.data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/jenjang.js